<template>
  <div id="airports" class="font-sans" data-test="airports">
    <h2 class="text-base xs:text-xl md:text-3xl font-cocogoose">
      {{ $i18n("general.our-airports") }}
    </h2>
    <div
      ref='airportsList'
      class="mt-7 md:px-[43px] md:py-7 p-[21px] bg-white border border-athens rounded-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 md:gap-x-18 md:gap-y-5 gap-y-2 overflow-hidden"
      :style="{ maxHeight: showAll ? 'none' : isMobile ? '345px' : '299px' }"
      @click="sendEvent('showAllAirportsClicked', 'Action Tracking', 'hom-airport-component');"
    >
      <a
        v-for="airport in airports"
        :key="airport.id"
        :href="formatUrl(airport.slug)"
        class="pb-0 truncate text-blue-600 text-base cursor-pointer"
      >
        {{ airport.name }}</a
      >
    </div>
    <button
      v-if="shouldShowButton"
      @click="toggleShowAll"
      class="mt-5 text-blue-600 underline text-base flex items-center"
    >
      <span>
        {{ showAll ? $i18n("general.show-less-airports") : $i18n("general.show-all-airports") }}
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ml-2 h-4 w-4 transform"
        :class="{ 'rotate-180': showAll }"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import {
  getCookie,
  nginxDecodeUserId,
} from '~/helpers/cookieHelpers';

export default {
  data() {
    return {
      showAll: false,
      isMobile: false,
      contentHeight: 0,
    };
  },
  computed: {
    airports() {
      return this.$store.state.airports;
    },
    shouldShowButton() {
      const threshold = this.isMobile ? 359 : 297;
      return this.contentHeight > threshold;
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.updateIsMobile);
    this.$nextTick(() => {
      this.updateContentHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    formatUrl(slug) {
      return `/${slug}/`;
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
      this.sendEvent('showAllAirportsClicked', 'Action Tracking', 'hom-airport-component');
    },
    async sendEvent(ea, ec, el) {
      const { host } = window.location;
      const pageType = () => window.$nuxt?.$store?.state?.bucket?.page_type || window.pageType;

      const visitorIdCookie = getCookie('uid');
      if (!visitorIdCookie) {
        console.log('[FLAGSHIP GTM] VisitorId is not defined');
        return;
      }
      const visitorId = nginxDecodeUserId(visitorIdCookie);
      const flagshipEnvironmentId = getCookie('xpe');
      const flagshipEventsAPIEndpoint = this.$config.FLAGSHIP_EVENTS_API_BASE_URL;

      const response = await fetch(
        `${flagshipEventsAPIEndpoint}?host=${host}&app=${pageType()}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            cid: flagshipEnvironmentId,
            vid: visitorId,
            dl: document.location.href,
            ds: 'APP',
            ev: 1,
            t: 'EVENT',
            ea,
            ec,
            el,
          }),
        },
      );
      if (response.status !== 200) {
        console.error(
          `[FLAGSHIP GTM] Event could not be be sent, HTTP ${response.status}`,
        );
      }
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 768;
      this.$nextTick(() => {
        this.updateContentHeight();
      });
    },
    updateContentHeight() {
      const element = this.$refs.airportsList;
      if (element) {
        this.contentHeight = element.scrollHeight;
      }
    },
  },
  watch: {
    airports: {
      handler() {
        this.$nextTick(() => {
          this.updateContentHeight();
        });
      },
      immediate: true,
    },
  },
};
</script>
